export const CALL_API = Symbol('CALL_API')

const resStatusError = [400, 401, 402, 403, 404, 422, 500]

function getAction(type, action, state, res) {
	return new Promise((resolve, reject) => {
		if (!res) return resolve({ type })

		if (resStatusError.includes(res.status)) {
			if (res.status === 422) {
				return res.json().then(json => {
					var message = ""
					for (const key in json) {
						if (json.hasOwnProperty(key)) {
							const element = json[key];
							for (const k in element) {
								if (element.hasOwnProperty(k)) {
									const ele = element[k];
									message += `${ele.msg}`
									if (ele.param) message += ' Param : ' + `${ele.param} `
									message += "\n"
								}
							}

						}
					}

					return reject({
						statusText: res.statusText, data: {
							code: res.status.toString(),
							message: message
						}
					})
				})
			} else {
				return res.json().then(data => reject({ statusText: res.statusText, data: data }))
			}
		}

		if (typeof type === 'object') {
			if (type.payload) {
				const payload = type.payload(action, state, res)
				if (typeof payload.then === 'function') { //promise
					return payload.then(data => resolve({ type: type.type, payload: data }))
				} else {
					return resolve({ type: type.type, payload })
				}
			}

			return resolve({ type: type.type })
		}

		res.json().then(payload => resolve({ type, payload }))
	})
}

export default ({ getState }) => next => action => {
	if (typeof action[CALL_API] !== 'object') return next(action)
	const {
		endpoint,
		method = 'GET',
		headers,
		body,
		types
	} = action[CALL_API]

	const [request, success, failure] = types
	const { callBack } = success
	const state = getState()

	getAction(request, action, state).then(action => next(action))

	if (callBack) {
		fetch(endpoint, { method, headers, body })
			.then(res => getAction(success, action, state, res))
			.then(action => {
				callBack(action)
				next(action)
			})
			.catch(err => next({ type: failure, payload: err, error: true, errorData: err.data }))
	} else {
		fetch(endpoint, { method, headers, body })
			.then(res => getAction(success, action, state, res))
			.then(action => next(action))
			.catch(err => next({ type: failure, payload: err, error: true, errorData: err.data }))
	}
}


// WEBPACK FOOTER //
// ./src/middlewares/api.js